package com.eladfinish.bible.contest.ui

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.LinkAnnotation
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextLinkStyles
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.withLink
import androidx.compose.ui.unit.TextUnit

fun getAnnotatedStringForLink(
    fullText: String,
    hyperLinks: Map<String, String>, // linkText -> url
    linkTextColor: Color,
    fontSize: TextUnit,
    linkTextFontWeight: FontWeight,
    linkTextDecoration: TextDecoration,
): AnnotatedString {
    return buildAnnotatedString {
        // Default style for the whole text (optional, matches your previous behavior)
        addStyle(
            style = SpanStyle(fontSize = fontSize),
            start = 0,
            end = fullText.length
        )

        var cursor = 0

        // Replace each occurrence of link text with a LinkAnnotation range
        while (cursor < fullText.length) {
            // Find the next link occurrence (earliest match after cursor)
            val next = hyperLinks
                .mapNotNull { (linkText, url) ->
                    // An empty linkText would match at `cursor` on every iteration without ever
                    // advancing it (start + linkText.length == cursor), looping forever — skip it.
                    if (linkText.isEmpty()) return@mapNotNull null
                    val idx = fullText.indexOf(linkText, startIndex = cursor)
                    if (idx >= 0) Triple(idx, linkText, url) else null
                }
                .minByOrNull { it.first }

            if (next == null) {
                append(fullText.substring(cursor))
                break
            }

            val (start, linkText, url) = next

            // Append non-link text before the match
            if (start > cursor) {
                append(fullText.substring(cursor, start))
            }

            // Append clickable segment using LinkAnnotation.Url
            withLink(
                LinkAnnotation.Url(
                    url = url,
                    styles = TextLinkStyles(
                        style = SpanStyle(
                            color = linkTextColor,
                            fontSize = fontSize,
                            fontWeight = linkTextFontWeight,
                            textDecoration = linkTextDecoration,
                        )
                    )
                )
            ) {
                append(linkText)
            }

            cursor = start + linkText.length
        }
    }
}
